// initial state
const state = {
  options: {
    status: [
      {label: '新创建', value: 0},
      {label: '上线', value: 1},
      {label: '下线', value: 2},
    ],
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const launchPageActivity = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/launch-page-activity/launch-page-activity.store.js